import { render } from "./networkUserCard.vue?vue&type=template&id=49dfa882&scoped=true"
import script from "./networkUserCard.vue?vue&type=script&lang=js"
export * from "./networkUserCard.vue?vue&type=script&lang=js"

import "./networkUserCard.vue?vue&type=style&index=0&id=49dfa882&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49dfa882"]])

export default __exports__